module.exports = __webpack_public_path__ + "static/media/users.079f17cf.svg";